import React, { useState, useEffect } from 'react';
import ProjectNavigator from './projectNavigator';
import './project.css';

const ProjectShowcase = ({projectsList, currentProject}) => {
  console.log("projectList: ", projectsList);  // Debugging line
  console.log("currentProject: ", currentProject);  // Debugging line
  const [columns, setColumns] = useState(4); // Default to large screens

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth >= 1024) {
        setColumns(4); // Large screens
      } else {
        setColumns(2); // Small screens
      }
    };

    updateColumns(); // Set on load
    window.addEventListener('resize', updateColumns); // Listen for changes

    return () => window.removeEventListener('resize', updateColumns);
  }, []);

  return (
    <div className="relative max-w-[600px] lg:max-w-[1400px] mx-auto p-8">
      <div className="project-showcase">
        <ProjectNavigator projectList={projectsList} />
        <div className="flex flex-col lg:flex-row items-center gap-6 min-w-[100%]">
          {/* details */}
          <div className="lg:w-2/5 text-white p-4">
            {/*<h1 className="md:text-3xl text-2xl lg:text-right text-center mb-4">DISCOVERY CENTER</h1>*/}
            <div className="md:text-lg text-sm space-y-2 lg:text-right text-center tracking-wide">
              {Object.entries(currentProject.detail || {}).map(([key, value]) => (
                <p key={key}>
                  <span className=" custom-text-color">{key.charAt(0).toUpperCase() + key.slice(1)}:</span> <strong> {value} </strong>
                </p>
              ))}
            </div>
          </div>
          {/* text */}
          <div className=" lg:w-3/5 md:w-3/4">
            {/*<h1 className="md:text-3xl text-2xl lg:text-left text-center mb-4">PROJECT OVERVIEW</h1>*/}
            <p className="md:text-lg text-sm lg:text-left text-center tracking-wide">
              {currentProject.about}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectShowcase;